import store from "@/store/store";
export default function updateBalances() {
  if (store.getters["auth/getIfUserIsInvestor"] === true){
    const iid = store.getters["auth/getInvestorId"];

    axios.get(`/api/v2/investor/${iid}/getBalancesData`)
      .then(res => store.commit('auth/updateInvestorBalancesData', res.data))
      .catch(e => console.log(e));
  }
}